/* eslint-disable no-param-reassign */
/*
 *
 * Copyright © Tessell Inc, 2021. All rights reserved.
 *
 *     Date            Author                  Comment
 *   --------------------------------------------------
 *     9/4/2021     bakul.banthia         Created
 *
 */

import { createSlice } from '@reduxjs/toolkit';

export const payments = createSlice({
    name: 'paymentsData',
    initialState: {
        value: {},
    },
    reducers: {
        update: (state, action) => {
            state.value = action.payload;
        },
    },
});

export const { update } = payments.actions;

export default payments.reducer;
